module.exports = __webpack_public_path__ + "static/media/SincerelyDiaryInterior2.17afd528.jpg";